<template>
  <div class="row search-filter-category">
    <div class="col-12" >
      <a v-b-toggle="`collapse-${fieldName}-facet`" class="facet-collapse-icon c-pointer">
        <font-awesome-icon
          class="when-opened "
          icon='caret-down'
          size="lg" />
        <font-awesome-icon
          class="when-closed fa-w-10"
          icon='caret-right'
          size="lg" />
      </a>
      <span class="font-weight-bold ">{{ title }}</span>
      <b-collapse :id="`collapse-${fieldName}-facet`"
        class="row"

        :visible="initialSearchCategoryStates[fieldName]">
        <div v-if="loading" class="search-panel-items search-filter-list">
          <LoadingSpinner message ='Loading' size = '1x'>
          </LoadingSpinner>
        </div>
        <template v-else-if="onlyOneAllowed">
          <b-form-radio-group
            name="searchItems"
            class="scrollable-section search-panel-items search-filter-list"
            v-model="selectedOptions"
          >
            <b-form-radio
              v-for="option in options"
              :key="option.id"
              :value="option.id"
              class="col-md-12 noselect">
                {{ option.name }}
            </b-form-radio>
          </b-form-radio-group>
        </template>
        <template v-else-if="!onlyOneAllowed && !isInputTextBox">
          <b-form-checkbox-group
            name="searchItems"
            class="scrollable-section search-panel-items search-filter-list"
            v-model="selectedOptions"
          >
            <b-form-checkbox
              v-for="option in options"
              :key="option.id"
              :value="option.id"
              class="col-md-12 noselect">
                {{ option.name }}
            </b-form-checkbox>
          </b-form-checkbox-group>
        </template>
        <template v-else-if="isInputTextBox && fieldName === 'previousServices'">
          <b-input-group
            name="searchItems"
            class="scrollable-section search-panel-items search-filter-list"
          >
            <input class="form-control"
              v-validate="'numeric|min:1|previous_service_id_exists'"
              v-bind:placeholder="'Enter Service ID Number'"
              name="previousServices"
              data-vv-as="Previous Service ID"
              v-model="previousServices">
          <div class="invalid-feedback">{{errors.first('previousServices')}}</div>
          </b-input-group>
        </template>
      </b-collapse>
    </div>
  </div>
</template>
<script>
import LoadingSpinner from '../LoadingSpinner.vue';

export default {
  name: 'SearchFacetOptions',
  components: {
    LoadingSpinner,
  },
  props: {
    entityType: {
      type: String,
      default: 'Instrument',
    },
    title: {
      type: String,
    },
    fieldName: {
      type: String,
    },
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    onlyOneAllowed: {
      type: Boolean,
      default: false,
    },
    isInputTextBox: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    initialSearchCategoryStates() {
      return this.$store.state.Search.initialSearchCategoryStates;
    },
    selectedOptions: {
      get() {
        if (this.onlyOneAllowed) {
          if (this.$store.state.Search.selectedSearchFacets[this.fieldName]
            && this.$store.state.Search.selectedSearchFacets[this.fieldName].length > 0) {
            return this.$store.state.Search.selectedSearchFacets[this.fieldName][0];
          }
          return null;
        }
        return this.$store.state.Search.selectedSearchFacets[this.fieldName];
      },
      set(value) {
        this.$store.dispatch(
          'Search/updateSearchFacet',
          {
            type: this.fieldName,
            values: value,
          },
        );
      },
    },
    previousServices: {
      get() {
        if (this.$store.state.Search.selectedSearchFacets[this.fieldName]
          && this.$store.state.Search.selectedSearchFacets[this.fieldName].length > 0) {
          return this.$store.state.Search.selectedSearchFacets[this.fieldName][0];
        }
        return null;
      },
      set(value) {
        this.$store.dispatch(
          'Search/updateSearchFacet',
          {
            type: this.fieldName,
            values: value,
          },
        );
      },
    },
  },
};
</script>
